module.exports = __webpack_public_path__ + "static/media/10A.734e7a1d.jpg";